import { AppProvider } from "@/providers/app"

const App = () => <AppProvider />

export default App
